import Att from "public/techPartners/at&t.png";
import Cisco from "public/techPartners/cisco.png";
import Cogent from "public/techPartners/cogent.png";
import Cologix from "public/techPartners/cologix.png";
import Comcast from "public/techPartners/comcast.png";
import Eset from "public/techPartners/eset.png";
import Fortinet from "public/techPartners/fortinet.png";
import Inuvika from "public/techPartners/inuvika.png";
import PaloAlto from "public/techPartners/paloalto.png";
import Sophos from "public/techPartners/sophos.png";
import Teenable from "public/techPartners/teenable.png";
import Veeam from "public/techPartners/veeam.png";
import Zadara from "public/techPartners/zadara.png";
import Redhat from "public/techPartners/redhatArtboard-33.png";
import Opentext from "public/techPartners/opentextArtboard-70.png";
import Microsoft from "public/techPartners/microsoftArtboard-7.png";
import Juniper from "public/techPartners/juniperArtboard-53.png";
import Hpe from "public/techPartners/hpeArtboard-98.png";
import Eaton from "public/techPartners/eatonArtboard-100.png";
import Dell from "public/techPartners/dellArtboard-40.png";
import Checkpoint from "public/techPartners/checkpointArtboard-99.png";
import Commvault from "public/techPartners/commvault.png";
import Linkeye from "public/techPartners/linkeye.png";
import Crowdstrike from "public/techPartners/crowdstrike.png";
import Sentinelone from "public/techPartners/sentinelone.png";
import Nable from "public/techPartners/nable.png";
import Auvik from "public/techPartners/auvik.png";
import Platform9 from "public/techPartners/platform9.png";
import Linstor from "public/techPartners/linstor.png";

export const TECH_PARTNERS_CONSTANTS = {
  title: "Our Technology Partners",
  list: [
    { image: Cisco, name: "Cisco", href: "https://www.cisco.com/" },
    { image: Redhat, name: "Redhat", href: "https://www.redhat.com/" },
    { image: Cogent, name: "Cogent", href: "https://www.cogentco.com/" },
    { image: Inuvika, name: "Inuvika", href: "https://www.inuvika.com/" },
    { image: Eset, name: "ESET", href: "https://www.eset.com/" },
    { image: Microsoft, name: "Microsoft", href: "https://www.microsoft.com/" },
    { image: Fortinet, name: "Fortinet", href: "https://www.fortinet.com/" },
    { image: Dell, name: "Dell", href: "https://www.dell.com/" },
    { image: PaloAlto, name: "Palo Alto", href: "https://www.paloaltonetworks.com/" },
    { image: Cologix, name: "Cologix", href: "https://www.cologix.com/" },
    { image: Comcast, name: "Comcast", href: "https://business.comcast.com/" },
    { image: Sophos, name: "Sophos", href: "https://www.sophos.com/" },
    { image: Teenable, name: "Tenable", href: "https://www.tenable.com/" },
    { image: Veeam, name: "Veeam", href: "https://www.veeam.com/" },
    { image: Att, name: "AT&T", href: "https://www.att.com/" },
    { image: Zadara, name: "Zadara", href: "https://www.zadara.com/" },
    { image: Opentext, name: "OpenText", href: "https://www.opentext.com/" },
    { image: Juniper, name: "Juniper", href: "https://www.juniper.net/" },
    { image: Hpe, name: "HPE", href: "https://www.hpe.com/" },
    { image: Eaton, name: "Eaton", href: "https://www.eaton.com/" },
    { image: Checkpoint, name: "Check Point", href: "https://www.checkpoint.com/" },
    { image: Commvault, name: "Commvault", href: "https://www.commvault.com/" },
    { image: Linkeye, name: "LinkEye", href: "https://linkeye.ai/" },
    { image: Crowdstrike, name: "CrowdStrike", href: "https://www.crowdstrike.com/" },
    { image: Sentinelone, name: "SentinelOne", href: "https://www.sentinelone.com/" },
    { image: Nable, name: "N-able", href: "https://www.n-able.com/" },
    { image: Auvik, name: "Auvik", href: "https://www.auvik.com/" },
    { image: Platform9, name: "Platform9", href: "https://platform9.com/" },
    { image: Linstor, name: "LINSTOR", href: "https://linbit.com/linstor/" },
  ],
};
